module.exports = __webpack_public_path__ + "img/文字_E级赛事@2x.5ece1a62.png";